import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MasterHomePage } from './master-home.page';

const routes: Routes = [
  {
    path: '',
    component: MasterHomePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class MasterHomePageRoutingModule {}
